module.exports = __webpack_public_path__ + "img/alimenticioImage.5cff3f2b.svg";